'use strict';
const Ajax = require('common/infra/ajax');

class API {
    /**
     * ActionType を取得する
     *
     * @param projectId
     * @param actionTypeId
     * @returns {*}
     */
    getActionType(projectId, actionTypeId) {
        return Ajax.GET(`/api/projects/${projectId}/action-types/${actionTypeId}`);
    }

    /**
     * ActionType の一覧を取得する
     *
     * @param projectId
     * @returns {*}
     */
    getActionTypes(projectId) {
        return Ajax.GET(`/api/projects/${projectId}/action-types`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./process/infra/api/action/type.js